import React, { useState, useEffect } from 'react';
import { fetchEmailOptOut, createEmailOptOut, deleteEmailOptOut } from '../api';
import './emailoptoutcontrol.css';

const formatDate = (iso) => new Date(iso).toLocaleDateString([], { month: 'short', day: 'numeric', year: 'numeric' });

// Staff-only "stop all emails" for a customer who asked (by email, phone or in person).
// Keyed by the email address, so it also covers their future website bookings. Customers
// never see this — there's deliberately no unsubscribe link in the emails themselves.
const EmailOptOutControl = ({ email }) => {
  const [status, setStatus] = useState(null);
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    setStatus(null);
    setError(null);
    if (!email) return;
    fetchEmailOptOut(email)
      .then(setStatus)
      .catch(() => setError('Could not load email preference.'));
  }, [email]);

  if (!email || !status) {
    return error ? <span className="email-optout-error">{error}</span> : null;
  }

  const handleStop = async () => {
    const note = window.prompt(
      `Stop ALL emails to ${email}? This includes confirmations and reminders for future bookings.\n\n`
      + 'How did they ask? (e.g. "Called 10/3, spoke to Sam")',
    );
    if (note === null) return;
    setBusy(true);
    setError(null);
    try {
      setStatus(await createEmailOptOut(email, note));
    } catch (err) {
      setError('Could not save. Try again.');
    } finally {
      setBusy(false);
    }
  };

  const handleResume = async () => {
    if (!window.confirm(`Start emailing ${email} again?`)) return;
    setBusy(true);
    setError(null);
    try {
      setStatus(await deleteEmailOptOut(email));
    } catch (err) {
      setError('Could not save. Try again.');
    } finally {
      setBusy(false);
    }
  };

  if (status.opted_out) {
    return (
      <div className="email-optout email-optout-off">
        <span className="email-optout-badge">Emails off</span>
        <span className="email-optout-detail">
          Asked {formatDate(status.created_at)}
          {status.created_by_name ? ` · set by ${status.created_by_name}` : ''}
          {status.note ? ` · ${status.note}` : ''}
        </span>
        <button type="button" className="email-optout-btn" onClick={handleResume} disabled={busy}>
          Turn emails back on
        </button>
        {error && <span className="email-optout-error">{error}</span>}
      </div>
    );
  }

  return (
    <div className="email-optout">
      <button type="button" className="email-optout-btn" onClick={handleStop} disabled={busy}>
        Stop all emails
      </button>
      {error && <span className="email-optout-error">{error}</span>}
    </div>
  );
};

export default EmailOptOutControl;
